import MissParlorDetailFlowerModalContent from "@/containers/MissParlorDetailContainer/components/MissParlorDetailFlowerModalContent";
import { useOverlay } from "@toss/use-overlay";
import { useResponsive, OverlayModal } from "goi_common";
import { useRouter } from "next/router";
import { useCallback } from "react";

export const useOpenFlowerModal = ({
  companyName,
  parlorId,
}: {
  companyName: string;
  parlorId: string;
}) => {
  const router = useRouter();
  const { query } = router;

  const overlay = useOverlay();
  const { isBiggerThanLg } = useResponsive();

  const openFlowerModal = useCallback(() => {
    overlay.open(({ isOpen, close: onClose }) => {
      return (
        <OverlayModal
          onClose={() => {
            router.replace({
              query: { ...query, showFlowerModal: false },
            });
            onClose();
          }}
          isOpen={isOpen}
          closeOnOverlayClick={true}
          modalContentStyle={{
            minWidth: "380px",
            minHeight: isBiggerThanLg ? "" : "90vh",
          }}
          overlayModalContent={
            <MissParlorDetailFlowerModalContent
              companyName={companyName}
              parlorId={Number(parlorId)}
              onClose={() => {
                router.replace({
                  query: { ...query, showFlowerModal: false },
                });
                onClose();
              }}
            />
          }
          header={{
            content: (
              <MissParlorDetailFlowerModalContent.header
                onClose={() => {
                  router.replace({
                    query: { ...query, showFlowerModal: false },
                  });
                  onClose();
                }}
              />
            ),
          }}
        />
      );
    });
  }, [overlay, isBiggerThanLg]);

  return {
    openFlowerModal,
  };
};
